import { useState } from "react";
import UsersManager from "../components/settings/UsersManager";
import CatalogManager from "../components/settings/CatalogManager";
import StatusesManager from "../components/settings/StatusesManager";
import CompaniesManager from "../components/settings/CompaniesManager";
import MessagesManager from "../components/settings/MessagesManager";

const TABS = [
  { key: "users", label: "Uživatelé" },
  { key: "programs", label: "Programy" },
  { key: "grades", label: "Stupně" },
  { key: "sellers", label: "Prodejci" },
  { key: "statuses", label: "Stavy" },
  { key: "companies", label: "Fakturační společnosti" },
  { key: "messages", label: "Hlášky (login)" },
];

export default function Settings() {
  const [tab, setTab] = useState("users");

  return (
    <>
      <div className="h-16 border-b border-border px-8 flex items-center sticky top-0 bg-background/80 backdrop-blur-md z-10">
        <h1 className="font-heading text-xl font-semibold tracking-tight">Nastavení</h1>
      </div>
      <div className="px-8 border-b border-border flex gap-1 overflow-x-auto">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`settings-tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`px-4 h-11 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${tab === t.key ? "border-foreground font-medium" : "border-transparent text-muted-foreground hover:text-foreground"}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="p-8">
        {tab === "users" && <UsersManager />}
        {tab === "programs" && <CatalogManager title="Programy workshopů" endpoint="/admin/programs" hasPrice />}
        {tab === "grades" && <CatalogManager title="Stupně škol" endpoint="/admin/grades" />}
        {tab === "sellers" && <CatalogManager title="Prodejci" endpoint="/admin/sellers" />}
        {tab === "statuses" && <StatusesManager />}
        {tab === "companies" && <CompaniesManager />}
        {tab === "messages" && <MessagesManager />}
      </div>
    </>
  );
}
